import React from 'react';
import { Button, Card, Grid } from '@material-ui/core';
import { InfoTooltip } from 'components';


interface ICsvValidation {
  validation: IBulkPriceValidation;
  fileName: string;
  onReset: () => void;
  onProceed: () => void;
}

const CsvValidation = ({ validation, fileName, onReset, onProceed }: ICsvValidation) => {
  const { errors, validCount, errorCount } = validation;
  const errorRows = errors.map(({ row }) => row).filter(Boolean).join(', ');

  return (
    <Card elevation={0} className="mt-5 p-8">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <div className="text-13 text-muted">File</div>
          <div className="font-bold">{fileName}</div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <div className="text-13 text-muted">Rows that can be applied</div>
          <div className="font-bold text-success">{validCount}</div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <div className="text-13 text-muted">Rows with problems</div>
          <div className="font-bold text-error">
            {errorCount}
            {Boolean(errorRows) &&
              <InfoTooltip title={`Rows: ${errorRows}`} />
            }
          </div>
        </Grid>
      </Grid>

      {Boolean(errorCount) &&
        <div className="mt-4">
          <table className="w-full text-13">
            <thead>
              <tr>
                <th className="text-left p-1">Row</th>
                <th className="text-left p-1">SKU</th>
                <th className="text-left p-1">Problem</th>
              </tr>
            </thead>
            <tbody>
              {errors.map((error, index) => (
                <tr key={`${error.row}-${index}`} className="text-white bg-error">
                  <td className="p-1">{error.row || '-'}</td>
                  <td className="p-1">{error.sku || '-'}</td>
                  <td className="p-1">{error.reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="text-13 text-muted mt-2">
            Every row has to be valid before a run can start. Fix the file and upload it again.
          </div>
        </div>
      }

      <div className="flex justify-center mt-5">
        <Button variant="outlined" className="uppercase mr-2" onClick={onReset}>
          Upload a different file
        </Button>
        <Button
          color="primary"
          variant="contained"
          className="uppercase"
          disabled={Boolean(errorCount) || !validCount}
          onClick={onProceed}
        >
          Continue
        </Button>
      </div>
    </Card>
  );
};

export default React.memo(CsvValidation);
